import React from 'react'

// Toastr
import Toastr from 'fw/components/toastr/Toastr';

// Modals
import ModalAlert from 'fw/modals/alert/Alert';
import ModalInfo from 'fw/modals/info/Info';
import ModalConfirm from 'fw/modals/confirm/Confirm';
import ModalUnsaved from 'fw/modals/unsaved/Unsaved';
import ModalRemove from 'fw/modals/remove/Remove';
import ModalInline from 'fw/modals/inline/Inline';
import ModalAuthentication from 'fw/modals/authentication/Authentication';

// Globals
import * as Modals from 'fw/globals/Modals';
import * as Notifications from 'fw/globals/Notifications';

// Vendors CSS
import 'react-block-ui/style.css';

class Framework extends React.Component {
    render() {
        return (
            <React.Fragment>
                {/* Notificaftions */}
                <Toastr ref={Notifications.hookToastr} />

                {/* Modals */}
                <ModalAlert ref={Modals.hookAlert} />
                <ModalInfo ref={Modals.hookInfo} />
                <ModalConfirm ref={Modals.hookConfirm} />
                <ModalUnsaved ref={Modals.hookUnsaved} />
                <ModalRemove ref={Modals.hookRemove} />
                <ModalInline ref={Modals.hookInline} />
                <ModalAuthentication ref={Modals.hookAuthentication} />
            </React.Fragment>);
    }
}

export default Framework;



// WEBPACK FOOTER //
// ./src/fw/components/framework/Framework.js